import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FieldView } from '../shared/config-response';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-title-field',
    templateUrl: './title-field.component.html',
    styleUrls: ['./title-field.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TitleFieldComponent implements OnInit {

  @Input() fields: Array<string> = [];
  @Input() doc: any;
  @Input() item?: FieldView;

  result_num: number = 0;
  result_title: string = "";
  result_url: string = "";
  result_string: string = "";
  date: string | null | undefined = "";
  author: string | null | undefined = "";

  constructor(private san: DomSanitizer) {}

  ngOnInit(): void {
    if (this.doc[this.fields[0]]) {
      this.result_title = this.doc[this.fields[0]];
    }
    if (this.doc[this.fields[1]]) {
      this.result_num = this.doc[this.fields[1]];
    }
    if (this.doc[this.fields[2]] != "") {
      this.result_url = this.doc[this.fields[2]];
    }
    // Date published field
    if (this.doc['date_published_display'] && this.doc['date_published_display'] !== '') {
      this.date = this.doc['date_published_display'];
    } else if (this.doc['date_published'] && this.doc['date_published'] !== 'unknown') {
      this.date = this.doc['date_published'];
      const datePipe = new DatePipe('en-US');
      this.date = datePipe.transform(this.date, 'MMMM d, yyyy');
    } else if (this.doc['date_published'] === 'unknown') {
      this.date = undefined;
    }
    // --- Author Normalisation ---
    const raw = this.doc['author'];

    if (Array.isArray(raw)) {
      // Array of objects or strings.  Pick "name" if object, keep string as‑is.
      this.author = raw
        .map(a =>
          typeof a === 'string'
            ? a
            : (a?.name ?? '')                 // fallback to empty string
        )
        .filter(Boolean)                     // drop empties
        .join(', ');
    } else {
      // single string or nullish
      this.author = raw || undefined;
    }
  
    // No longer concatenate result_num
    this.result_string = this.result_title;
  }

  // Renderable HTML version (safe)
  get authorHtml(): SafeHtml {
    return this.san.bypassSecurityTrustHtml(this.author || '');
  }

  // Plain‑text version for tooltip
  get authorPlain(): string {
    return (this.author || '').replace(/<\/?em>/gi, '');
  }
}
